import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import { injectIntl } from "react-intl";
import FormAdvancedField from "components/form/form-advanced-field";
import { AssetFormTypeProvider } from "pages/asset";
import { AssetDisplay } from "components/thumbnail";
import {getAssetCategoriesService, getAssetsByCustomer} from "../../../../../services/commonService";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import DialogNewShieldApi from "./dialog-new-shield-api";

const LogoAssetApiForm = ({ customerIdSelected, assetId, asset, handleChange, intl, assetPath, assetIdPath, team, classes, register, watch }) => {
  const [openDialogNewShield, setOpenDialogNewShield] = useState(false);
  const [shieldId, setShieldId] = useState(null);

  const [assets, setAssets] = useState([]);
  const [assetCategories, setAssetCategories] = useState([]);
  const [defaultCategory, setDefaultCategory] = useState(null);

  useEffect(() => {
    setShieldId(assetId || null);
  },[assetId]);

  const handleClickOpenDialogNewShield = () => {
    setOpenDialogNewShield(true);
  };

  const handleCloseDialogNewShield = () => {
    setOpenDialogNewShield(false);
  };

  const assetsCallback = (r) => {
    setAssets(r)
  };

  const assetCategoriesCallback = (r) => {
    const shieldCategoryId = r.find(c => c.codename === "TEAM_SHIELD");
    setAssetCategories(r);
    setDefaultCategory(shieldCategoryId);
    if (!!shieldCategoryId) {
      getAssetsByCustomer(customerIdSelected, {format: "png", categoryIds: [shieldCategoryId?._id]}, assetsCallback);
    }
  }

  useEffect(() => {
    getAssetCategoriesService(assetCategoriesCallback)
  }, [])

  return (
    <AssetFormTypeProvider>
      <DataGridItem big>
          <DataGridItem big>
            <FormControl className={classes.fullWidth}>
              <InputLabel id="common.asset.selectShield">{intl.formatMessage({id: "common.asset.selectShield"})}</InputLabel>
                  <Select {...register(assetIdPath)}
                    getLabelFromElement={item => item.description}
                    getValueFromElement={item => item._id ?? ""}
                          value={watch(assetIdPath) ?? ""}
                    id={assetIdPath}>
                      {assets?.map((a) => (
                        <MenuItem key={a._id} value={a._id}>
                          {a.description}
                        </MenuItem>))}
                  </Select>
            </FormControl>
            <DataGridItem big>
          <DialogNewShieldApi
            asset={asset}
            customerIdSelected={customerIdSelected}
            handleChange={handleChange}
            intl={intl}
            openDialogNewShield={openDialogNewShield}
            handleCloseDialogNewShield={handleCloseDialogNewShield}
            assetPath={assetPath}
            team={team}
            assetCategories={assetCategories}
            defaultCategory={defaultCategory}
            register={register}
          />
          <FormAdvancedField
            onVisibilityChange={handleClickOpenDialogNewShield}
            label={intl.formatMessage({ id: "app.form.graphicset.asset.new" })} />
        </DataGridItem>
          </DataGridItem>
        {shieldId && (
            <DataGridItem big>
              <AssetDisplay asset={{ id: shieldId, customerId: customerIdSelected, format: "png" }} width={150} />
            </DataGridItem>
        )}
      </DataGridItem>
    </AssetFormTypeProvider>
  );
};

LogoAssetApiForm.propTypes = {
  /**
   * Función que se invoca al modificar algún valor
   */
  handleChange: PropTypes.func,
  /**
   * Objeto con los valores que se quieren representar
   */
  asset: PropTypes.string,
  /**
   * Id del asset seleccionado
   */
  assetId: PropTypes.string,
  /**
   * Customer id a utilizar en la query de assets
   */
  customerIdSelected: PropTypes.string,
  /**
   * Path del asset en los datos
   */
  assetPath: PropTypes.string,
  /**
   * Path del assetId en los datos
   */
  assetIdPath: PropTypes.string,
};

export default injectIntl(LogoAssetApiForm);
